import EverythingButton from '../Buttons/everythingButton';
import OverviewButton from '../Buttons/overviewButton';

export default function LiteButtons() {
	return (
		<>
			<OverviewButton classes={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home']} />
			<EverythingButton />
		</>
	);
}
